module.exports = __webpack_public_path__ + "img/bg_dashboard_normal_bar.b4a1fbc.png";